import { Injectable } from '@angular/core';
import CodiceFiscale from 'codice-fiscale-js';
@Injectable({ providedIn: 'root' })
export class FiscalCodeService {
 generateFiscalCode(data: {
   firstName: string;
   lastName: string;
   gender: 'M' | 'F';
   birthDate: Date;
   birthCity: string;
   birthProvince: string;
 }): string {
    const CF = (CodiceFiscale as any).CodiceFiscale;
    return CF.compute({
      name: data.firstName,
      surname: data.lastName,
      gender: data.gender,
      day: data.birthDate.getDate(),
      month: data.birthDate.getMonth() + 1,
      year: data.birthDate.getFullYear(),
      birthplace: data.birthCity,
      birthplaceProvincia: data.birthProvince,
    });
  }
 extractData(fiscalCode: string) {
   const CF = (CodiceFiscale as any).CodiceFiscale;
    return new CF(fiscalCode);
 }

 isFiscalCodeValid(fiscalCode: string): boolean {
    const CF = (CodiceFiscale as any).CodiceFiscale;
    const cf = new CF(fiscalCode);
    console.log(cf);
    return cf.isValid();
 }
}